export const estDeviceTypes = ['energySavingTool', 'EST City', 'EST Site'] as const;
export const timePeriodOptions = ['day', 'week', 'month', 'year'] as const;
export const groupByOptions = ['Tags', 'Working Hours'] as const;

export type DeviceType = (typeof estDeviceTypes)[number];

export type TimeGroupingInterval = (typeof timePeriodOptions)[number];
export type GroupBy = (typeof groupByOptions)[number];

export type TimeRange = [number, number];
